// TODO: Support translation for formula dialog
import React, { useState, useEffect } from 'react';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Checkbox, Switch } from "@progress/kendo-react-inputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { getAllAttributes, getRelatedEntityAttributes } from "../../Helpers/Schema/Schema";
import AttributeTypes from "../AttributeTypes";
import { filterBy } from "@progress/kendo-data-query";
import NumericInput from "../Fields/NumericInput";
import FormulaLoader from '../../Shared/Loader/FormulaLoader';
import { useTranslation } from 'react-i18next';

const NumberAttr = ({ attrList, formula, operators, groupg, i, groupid, onAttribute1Change, onAttributeRowChange, onExpoChange, groupIndex, onAttribute2Change, onOperatorChange, onMultiOperatorChange, onRemoveRow, numberType, attributeType }) => {
    const [numOperator, setNumOperator] = useState([]);
    const [numDateOperator, setNumDateOperator] = useState([]);
    const [numAttribute, setNumAttribute] = useState([]);
    const [multiDateTimeOperators, setMultiDateTimeOperators] = useState([]);
    const [data, setData] = useState(attrList);
    const [isChangeType, setIsChangeType] = useState(false);
    const [isChangeControl, setIsChangeControl] = useState(false);
    const [eventInfo, setEventInfo] = useState([]);

    const { t, ready: tReady } = useTranslation([
        "attribute/formula",
    ]);

    const filterData = (filter) => {
        const data = attrList;
        return filterBy(data, filter);
    };

    let format = "n2";

    useEffect(() => {
        setData(numAttribute.slice());
    }, [numAttribute]);
    const filterChange = (event) => {
        setData(filterData(event.filter));
    };

    useEffect(() => {
        if (AttributeTypes && AttributeTypes.Operations) {
            var data = AttributeTypes.Operations.filter(obj => {
                return obj.type === "Number"
            })[0];
            setMultiDateTimeOperators(data.multiTimeOperators.concat(data.multiDateOperators));
        }
    }, []);

    useEffect(() => {
        if (AttributeTypes && AttributeTypes.Operations) {
            var data = AttributeTypes.Operations.filter(obj => {
                return obj.type === "Number"
            })[0];
            setNumOperator(data.operators.concat(data.linkedOperators) || []);
            if (groupg && groupg.field && groupg.field.length > 0) {
                const attr = attrList.find(attr => attr.attributeName === groupg.field);
                if (attr.attributeType === "Number") {
                    setNumDateOperator(data.multiOperators);
                } else {
                    setNumDateOperator(data.multiOperators.concat(multiDateTimeOperators) || []);
                }
            } else {
                setNumDateOperator(data.multiOperators);
            }
        }
        if (attrList)
            setNumAttribute(attrList);
    }, [multiDateTimeOperators]);

    const dsNumOperator = (groupg) => {
        let operators = [];
        let newdata = attrList.filter(obj => {
            return obj.attributeName === groupg.field;
        });
        if (groupg) {
            var data = AttributeTypes.Operations.filter(obj => {
                return obj.type === "Number"
            })[0];
            if (newdata && newdata.length > 0) {
                let isLinkedAttr = newdata[0].isLinkedAttr;
                if (isLinkedAttr) {
                    if (groupg.operatorS === 'exponent' || groupg.operatorS === 'absolute') {
                        groupg.operatorS = '';
                    }
                    if (newdata && newdata[0].isIdAttribute) {
                        operators = data.linkedOperators.filter(operator => operator !== "avg" && operator !== "sum")
                    } else {
                        operators = data.linkedOperators;
                    }
                }
                else {
                    operators = data.operators;
                }
            }
            else {
                operators = numOperator;
            }
        }
        else {
            operators = numOperator;
        }
        if (newdata[0] && newdata[0].numberType === "integer") {
            operators = operators.filter(operator => operator !== "ceil" && operator !== "floor" && operator !== "round");
        }
        return operators;
    }

    const dsOpratorEnable = (groupg, groupf, groupid) => {
        if (groupg) {

            let groupInfo = groupf.groups.filter(obj => obj.groupid === groupid);


            if (groupInfo && groupInfo[0].functions[0].fieldId !== groupg.fieldId) {
                if (groupInfo[0].functions[0].field !== '') {
                    let attrType = attrList.find(attr => attr.attributeName === groupInfo[0].functions[0].field);

                    if (attrType && attrType.attributeType === "DateTime") {
                        return true;
                    }
                }
            }
            let newdata = attrList.filter(obj => {
                return obj.attributeName === groupg.field;
            });
            if (newdata && newdata.length > 0) {

                if (newdata[0].attributeType === "DateTime") {
                    return true;
                }
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    const dsOprator2Enable = (groupg, groupf, groupid) => {

        if (groupg) {
            if (groupg.field === "Fixed Number" && groupg.value !== undefined && groupg.value.length <= 0) {
                return true;
            }
            else {
                let groupInfo = groupf.groups.filter(obj => obj.groupid === groupid);

                if (groupInfo && groupInfo[0].functions[0].fieldId !== groupg.fieldId) {

                    if (groupInfo[0].functions[0].field !== '') {
                        let attrType = attrList.find(attr => attr.attributeName === groupInfo[0].functions[0].field);
                        if (attrType && attrType.attributeType && attrType.attributeType === "DateTime") {
                            return true;
                        }
                    }
                }

                else {
                    return groupg.field !== undefined && groupg.field.length <= 0;
                }
            }
        }
        else {
            return false;
        }
    }

    const dsNumDateOperator = (groupg) => {
        if (groupg) {
            if (groupg.field === "" || !groupg.field) {
                ;
            }
            let newdata = attrList.filter(obj => {
                return obj.attributeName === groupg.field;
            });
            var data = AttributeTypes.Operations.filter(obj => {
                return obj.type === "Number"
            })[0];
            if (newdata && newdata.length > 0) {

                if (newdata[0].attributeType === "Number") {
                    return data.multiOperators;
                }
                else if (newdata[0].dateTimeType === "date") {
                    return data.multiDateOperators;
                }
                else if (newdata[0].dateTimeType === "time") {
                    return data.multiTimeOperators;
                }
                else {
                    return multiDateTimeOperators;
                }
            }
            else {
                return numDateOperator;
            }
        }
        else {
            return numDateOperator;
        }
    }

    const dsAttrList = (groupg, groupf, groupid) => {

        let attrFilterList = [];
        var data = AttributeTypes.Operations.filter(obj => {
            return obj.type === "Number"
        })[0];
        let attributesDropdownData = [];
        if (groupg) {
            if (groupf) {
                attrList = attrList.filter(item => item.attributeName !== groupf.name);
                let groupInfo = groupf.groups.filter(obj => obj.groupid === groupid);
                if (groupInfo && groupInfo[0].functions.length > 0 &&
                    groupInfo[0].functions[0].fieldId !== groupg.fieldId) {
                    if (groupInfo[0].functions[0].field !== '') {
                        let attrType = attrList.find(attr => attr.attributeName === groupInfo[0].functions[0].field);
                        if (attrType && attrType.attributeType)
                            attrFilterList = [...attrList.filter(attr => attr.attributeType === attrType.attributeType)];
                        if (groupInfo[0].functions[0].field === '@Today') {
                            attrFilterList = [...attrFilterList.filter(attr => attr.attributeName != '@Today')];
                        }


                        if (attrType && attrType.attributeType && (attrType.attributeType === "DateTime")) {
                            if (data.multiDateOperators.includes(groupInfo[0].functions[0].operatorM) && attrType.dateTimeType === "datetime") {
                                if (attrFilterList.length > 0)
                                    attrFilterList = [...attrFilterList.filter(attr => (attr.dateTimeType === "datetime" || attr.dateTimeType === 'date'))];
                                else
                                    attrFilterList = [...attrList.filter(attr => (attr.dateTimeType === "datetime" || attr.dateTimeType === 'date'))];
                            }
                            else if (data.multiDateOperators.includes(groupInfo[0].functions[0].operatorM) && attrType.dateTimeType === "date") {
                                if (attrFilterList.length > 0)
                                    attrFilterList = [...attrFilterList.filter(attr => (attr.dateTimeType === 'date'))];
                                else
                                    attrFilterList = [...attrList.filter(attr => (attr.dateTimeType === 'date'))];
                            }
                            else if (data.multiTimeOperators.includes(groupInfo[0].functions[0].operatorM)) {
                                if (attrFilterList.length > 0)
                                    attrFilterList = [...attrFilterList.filter(attr => (attr.dateTimeType === attrType.dateTimeType))];
                                else
                                    attrFilterList = [...attrList.filter(attr => (attr.dateTimeType === attrType.dateTimeType))];

                            }
                        }
                    }
                }
                else if (groupInfo && groupInfo[0].functions.length > 1
                    && groupInfo[0].functions[0].field !== '' && groupInfo[0].functions[1].field !== '') {
                    if (groupInfo[0].functions[1].field === '@Today') {
                        if (attrFilterList.length > 0)
                            attrFilterList = [...attrFilterList.filter(attr => attr.attributeName !== '@Today')];
                        else
                            attrFilterList = [...attrList.filter(attr => attr.attributeName !== '@Today')];
                    }
                }

            }

            if (groupg.field && groupg.field !== '') {
                let newdata = attrList.filter(obj => {
                    return obj.attributeName === groupg.field;
                });

                if (newdata && newdata.length > 0) {
                    let isLinkedAttr = newdata[0].isLinkedAttr;
                    if (isLinkedAttr && data.linkedOperators.includes(groupg.operatorS)) {
                        attributesDropdownData = attrList.filter((x) => x.isLinkedAttr === true);
                    }
                    else if (data.operators.includes(groupg.operatorS)) {
                        let filteredData = attrList.filter((x) => (x.isLinkedAttr === false && x.attributeType === 'Number'));
                        attributesDropdownData = (filteredData.length > 0) ? filteredData : attrList;
                    }
                    else {
                        attributesDropdownData = (attrFilterList.length > 0) ? attrFilterList : attrList;
                    }
                }
                else {
                    attributesDropdownData = (attrFilterList.length > 0) ? attrFilterList : attrList;
                }
            }
            else if (groupg.operatorS && groupg.operatorS !== '') {
                let operator = groupg.operatorS;

                if (data.linkedOperators.includes(operator)) {//If it is linked operator filter linked attribute
                    let filteredData = attrList.filter((x) => x.isLinkedAttr === true);
                    if (operator === "avg" || operator === "sum") {
                        filteredData = filteredData.filter((x) => !x.isIdAttribute);
                    }
                    attributesDropdownData = filteredData;
                }
                else if (data.operators.includes(operator)) {
                    let filteredData = attrList.filter((x) => x.isLinkedAttr === false && x.attributeType === "Number");
                    attributesDropdownData = filteredData;
                }
                else {
                    attributesDropdownData = (attrFilterList.length > 0) ? attrFilterList : attrList;
                }
            }
            else {
                attributesDropdownData = (attrFilterList.length > 0) ? attrFilterList : attrList;
            }
        }
        else {
            attributesDropdownData = (attrFilterList.length > 0) ? attrFilterList : attrList;
        }

        if (groupg && groupg.operatorS) {
            let operator = groupg.operatorS;
            if (
                operator === "ceil" || operator === "floor" || operator === "round"
            ) {
                attributesDropdownData = attributesDropdownData.filter((x) => x.numberType === "decimal");
            }
        }

        return attributesDropdownData;
    }

    const itemRender = (li, itemProps) => {
        const itemChildren =
            itemProps.dataItem.attributeName === 'Fixed Number' || itemProps.dataItem.attributeName === '@Today' ?
                <span className='sysName'>
                    {li.props.children}
                </span>
                :
                (<span>
                    {li.props.children}
                </span>)

        return React.cloneElement(li, li.props, itemChildren);
    }

    const onNumOperatorChange = (e) => {

        let operator = e.target.value;
        var data = AttributeTypes.Operations.filter(obj => {
            return obj.type === "Number"
        })[0];
        if (data.linkedOperators.includes(operator)) {//If it is linked operator filter linked attribute
            let filteredData = attrList.filter((x) => x.isLinkedAttr === true);
            if (operator === "avg") {
                filteredData = filteredData.filter(attribute => !attribute.isIdAttribute);
            }
            setNumAttribute(filteredData);
        }
        else if (data.operators.includes(operator)) {
            let filteredData = attrList.filter((x) => x.isLinkedAttr === false);
            filteredData.unshift({ attributeName: "Fixed Number", attributeType: "Number", isLinkedAttr: false });
            setNumAttribute(filteredData);
        }
        else {
            setNumAttribute(attrList);
        }
        onOperatorChange(e);
    }

    const cancelRemoveRowDialog = () => {
        setIsChangeControl(false);
        setIsChangeType(false);
    }

    const acceptRemoveRowDialog = () => {
        setIsChangeControl(true);
        onAttributeRowChange(eventInfo);
        setEventInfo([]);
        setIsChangeType(false);
    }

    const onNumAttrChange = (e) => {
        if (!isChangeType) {
            let groupid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupid') ? e.target.getAttribute('groupid') : e.target.props.groupid;
            let groupdataid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupdataid') ? e.target.getAttribute('groupdataid') : e.target.props.groupdataid;
            let attribute = e.target.value;
            let form = formula.groups.filter(e => e.groupid === groupid);
            let existingType = attrList.filter(e => e.attributeName === form[0].functions[0].field);
            if (form[0].functions.length > 1 && form[0].functions[0].groupdataid === groupdataid) {
                if (attribute === '' || attribute === null || (attribute !== '' && form[0].functions[0].field !== attribute.attributeName && existingType[0].attributeType != attribute.attributeType)) {
                    setIsChangeType(true);
                    let eventInfo = { targetVal: e.target.value, groupid: groupid, groupdataid: groupdataid };
                    setEventInfo(eventInfo);
                    return;
                }
            }
        }
        let selectedAttr = e.target.value;
        var data = AttributeTypes.Operations.filter(obj => {
            return obj.type === "Number"
        })[0];
        if (selectedAttr && selectedAttr.attributeName && selectedAttr.attributeName.length > 0 && selectedAttr.isLinkedAttr) {
            setNumOperator(data.linkedOperators || []);
        }
        else if (selectedAttr && selectedAttr.attributeName && selectedAttr.attributeName.length > 0 && !selectedAttr.isLinkedAttr) {
            setNumOperator(data.operators || []);
        }
        else {
            setNumOperator(data.operators.concat(data.linkedOperators) || []);
        }
        onAttribute1Change(e);
    }
    {/* 
      Number
      SOPE EXPO FILE FNUM OPER DELETE
      3          5          3     1
      3          3     2    3     1=> Fixed Number
      3     2    3          3     1=> Exponent
      3     1    3     1    3     1=> Exponent Fixed Number */}
    return (
        <>
            <div className="col-3">
                <ComboBox
                    data={dsNumOperator(groupg)}
                    name={groupg.operatorSId}
                    value={dsOpratorEnable(groupg, formula, groupid) ? (groupg.operatorS = '') : groupg.operatorS}
                    placeholder={t("operator_placeholder")}
                    groupdataid={groupg.groupdataid}
                    groupid={groupid}
                    filterable={true}
                    allowCustom={false}
                    className={groupg.isOperatorSInvalid ? "form-control-custom invalid-formula-field" : "form-control-custom"}
                    onChange={onNumOperatorChange}
                    disabled={dsOpratorEnable(groupg, formula, groupid)}
                /></div>
            <div className={groupg.field === "Fixed Number" ? "col-3" : groupg.operatorS === "exponent" ? "col-3" : "col-5"}>
                <ComboBox
                    className={groupg.isFieldInvalid ? "form-control-custom invalid-formula-field" : "form-control-custom"}
                    name={groupg.fieldId}
                    data={dsAttrList(groupg, formula, groupid)}
                    onFilterChange={filterChange}
                    textField="displayName"
                    dataItemKey="_id"
                    placeholder={t("property_placeholder")}
                    value={groupg.field ? data.filter((e) => { return e.attributeName === groupg.field })[0] : null}
                    groupid={groupid}
                    gds={groupg}
                    groupdataid={groupg.groupdataid}
                    filterable={true}
                    allowCustom={false}
                    onChange={onNumAttrChange}
                    itemRender={itemRender}
                /></div>
            {groupg.field === "Fixed Number" && (
                <div className={groupg.operatorS === "exponent" ? "col-1" : "col-2"}>
                    {/* <input type='number' placeholder="Fixed Number" className={g.isValueInvalid ? "form-control invalid-formula-field" : "form-control"} size="10" value={g.value} groupid={groupid} groupdataid={g.groupdataid} onChange={onAttribute2Change} /> */}
                    <NumericInput
                        className={groupg.isValueInvalid ? "form-control invalid-formula-field" : "form-control"}
                        name="Fixed Number"
                        format={format}
                        groupid={groupid}
                        groupdataid={groupg.groupdataid}
                        value={groupg.value ? groupg.value : ""}
                        onChange={onAttribute2Change}
                        placeholder="Fixed Number"
                    />
                </div>
            )}
            {groupg.operatorS === "exponent" && (
                <div className={groupg.field === "Fixed Number" ? "col-1" : "col-2"}>
                    {/* <input type='number' placeholder="Exponent" className={g.isExponentInvalid ? "form-control invalid-formula-field" : "form-control"} value={g.expValue} groupid={groupid} groupdataid={g.groupdataid} onChange={onExpoChange} onKeyDown={(evt) => (evt.key === '+'||evt.key === '-') && evt.preventDefault()} /> */}
                    <NumericInput
                        className={groupg.isExponentInvalid ? "form-control invalid-formula-field" : "form-control"}
                        name="Exponent"
                        format={format}
                        groupid={groupid}
                        groupdataid={groupg.groupdataid}
                        value={groupg.expValue ? groupg.expValue : ""}
                        onChange={onExpoChange}
                        placeholder="Exp"
                    />
                </div>
            )}
            <div className="col-3">
                <ComboBox
                    data={dsNumDateOperator(groupg)}
                    name={groupg.operatorMId}
                    value={groupg.operatorM}
                    groupdataid={groupg.groupdataid}
                    placeholder={t("operator_placeholder")}
                    groupid={groupid}
                    filterable={true}
                    allowCustom={false}
                    key={i}
                    disabled={dsOprator2Enable(groupg, formula, groupid)}
                    className={groupg.isOperatorMInvalid ? "form-control-custom invalid-formula-field" : "form-control-custom"}
                    onChange={onMultiOperatorChange}
                /></div>
            <div className="col-1">
                {((i === 0 && groupIndex === 0) ? <></> : <> <span className="formula-row-close" onClick={onRemoveRow} groupid={groupid} groupdataid={groupg.groupdataid}> <i className="fa-solid fa-xmark-large "></i> </span> </>)} {groupg.isCircular && (<span className="formula-row-close"><i class="fa-solid fa-triangle-exclamation text-danger" aria-hidden="true"></i></span>)} {groupg.isWarning && (<span className="formula-row-close ms-3"><i class="fa-solid fa-triangle-exclamation text-danger" aria-hidden="true"></i></span>)}</div>
            {isChangeType &&
                <DeleteRows
                    cancelRemoveRowDialog={cancelRemoveRowDialog}
                    acceptRemoveRowDialog={acceptRemoveRowDialog}
                />
            }
        </>
    );
};

const Dropdowns = ({ attrList, formula, operators, groupData, groupid, onAttribute1Change, groupIndex, onAttribute2Change, setAttribute2Value, onExpoChange, onOperatorChange, onMultiOperatorChange, onRemoveRow, numberType, onAttributeRowChange }) => {
    const [data, setData] = React.useState(attrList);

    const filterData = (filter) => {
        const data = attrList;
        return filterBy(data, filter);
    };
    const checkEmpty = (evt) => {
        if (evt.target.value === "") {
            evt.target.value = "1";
            onAttribute2Change(evt);
        }
    }

    const  { t, ready: tReady } = useTranslation([
        "attribute/formula",
    ]);

    const isNumber = (evt) => {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode === 37 || charCode === 39) {
            return true;
        }
        if ((charCode > 31 && ((evt.target.value.length == 0 && charCode == 48) || charCode < 48 || charCode > 57))) {
            return false;
        }
        return true;
    }

    const handleAttribute2Change = (e) => {
        if (!isNaN(e.target.value)) {
            setAttribute2Value(e);
        }
    }

    function getStringData() {
        if (groupIndex === 0) {
            // do not return spaceAttribute and commaAttribute
            return data.filter(item => item.attributeName !== "Space" && item.attributeName !== "Comma");
        }
        return data;
    }

    useEffect(() => {
        setData(attrList.slice());
    }, [attrList]);
    const filterChange = (event) => {
        setData(filterData(event.filter));
    };

    return (
        <>
            {groupData && groupData.length > 0 && (groupData.map((groupg, i) => (
                <>
                    <div className="row m-3 pb-0 me-0">
                        {operators.type === "DateTime" && (<>
                            <div className="col-5">
                                <ComboBox
                                    className={groupg.isFieldInvalid ? "form-control-custom invalid-formula-field" : "form-control-custom"}
                                    name={groupg.fieldId}
                                    data={data.filter((e) => e.dateTimeType !== "time")}
                                    placeholder={t("property_placeholder")}
                                    onFilterChange={filterChange}
                                    textField="displayName"
                                    dataItemKey="id"
                                    value={groupg.field ? data.filter((e) => { return e.attributeName === groupg.field })[0] : null}
                                    groupid={groupid}
                                    groupdataid={groupg.groupdataid}
                                    filterable={true}
                                    allowCustom={false}
                                    onChange={onAttribute1Change} />
                            </div>

                            <div className="col-3"><ComboBox
                                data={operators.operators}
                                name={groupg.operatorSId}
                                value={groupg.operatorS}
                                placeholder={t("operator_placeholder")}
                                groupdataid={groupg.groupdataid}
                                groupid={groupid}
                                filterable={true}
                                allowCustom={false}
                                disabled={groupg.field <= 0}
                                className={groupg.isOperatorSInvalid ? "form-control-custom invalid-formula-field" : "form-control-custom"}
                                onChange={onOperatorChange} />
                            </div>

                            <div className="col-3">
                                <div className="d-flex justify-content-between">
                                    <button type="button" className="btn btn-secondary" disabled={(groupg.operatorS !== undefined && groupg.operatorS.length <= 0)} groupid={groupid} groupdataid={groupg.groupdataid} action="-" onClick={onAttribute2Change}>-</button>
                                    <input type='text' className="mx-2 text-center form-control" onBlur={checkEmpty} onChange={handleAttribute2Change} groupid={groupid} groupdataid={groupg.groupdataid} size="5" value={groupg.value} />
                                    <button type="button" className="btn btn-secondary" disabled={(groupg.operatorS !== undefined && groupg.operatorS.length <= 0)} groupid={groupid} groupdataid={groupg.groupdataid} action="+" onClick={onAttribute2Change}>+</button>
                                </div>
                            </div>
                            <div className="col-1 pe-0 ps-2 pt-1">
                                {groupg.isCircular && (<span className="formula-row-close"><i class="fa-solid fa-triangle-exclamation text-danger" aria-hidden="true"></i></span>)}{groupg.isWarning && (<span className="formula-row-close"><i class="fa-solid fa-triangle-exclamation text-danger" aria-hidden="true"></i></span>)}
                            </div>

                        </>)}
                        {operators.type === "Number" && (<NumberAttr
                            attrList={attrList}
                            formula={formula}
                            operators={operators}
                            groupData={groupData}
                            groupid={groupid}
                            groupIndex={groupIndex}
                            onExpoChange={onExpoChange}
                            groupg={groupg}
                            i={i}
                            onRemoveRow={onRemoveRow}
                            numberType={numberType}
                            onAttribute1Change={onAttribute1Change}
                            onAttributeRowChange={onAttributeRowChange}
                            onAttribute2Change={onAttribute2Change}
                            onOperatorChange={onOperatorChange}
                            onMultiOperatorChange={onMultiOperatorChange}

                        />)}
                        {operators.type === "String" && (<>
                            <div className="col-5">
                                <ComboBox
                                    className={groupg.isFieldInvalid ? "form-control-custom invalid-formula-field" : "form-control-custom"}
                                    name={groupg.fieldId}
                                    data={getStringData()}
                                    onFilterChange={filterChange}
                                    textField="displayName"
                                    placeholder={t("property_placeholder")}
                                    dataItemKey="_id"
                                    value={groupg.field ? data.filter((e) => { return e.attributeName === groupg.field })[0] : null}
                                    groupid={groupid}
                                    groupdataid={groupg.groupdataid}
                                    filterable={true}
                                    allowCustom={false}
                                    onChange={onAttribute1Change}
                                    itemRender={(li, itemProps) => {
                                        return React.cloneElement(
                                            li,
                                            li.props,
                                            <span className={itemProps.dataItem.attributeName === "Space" || itemProps.dataItem.attributeName === "Comma" ? "sysName" : ""}>
                                                {li.props.children}
                                            </span>
                                        );
                                    }} />
                            </div>
                            <div className="col-5">
                                <ComboBox
                                    data={operators.operators}
                                    name={groupg.operatorSId}
                                    value={groupg.operatorS}
                                    placeholder={t("operator_placeholder")}
                                    groupdataid={groupg.groupdataid}
                                    groupid={groupid}
                                    filterable={true}
                                    allowCustom={false}
                                    disabled={groupg.field <= 0}
                                    className="form-control-custom"
                                    onChange={onOperatorChange}
                                />
                            </div>
                            <div className="col-2">
                                {((i === 0 && groupIndex === 0) ? <></> : <> <span className="formula-row-close me-2" onClick={onRemoveRow} groupid={groupid} groupdataid={groupg.groupdataid}> <i className="fa-solid fa-xmark-large "></i> </span> </>)}{groupg.isCircular && (<span className="formula-row-close me-2"><i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i></span>)} {groupg.isWarning && (<span className="formula-row-close"><i class="fa-solid fa-triangle-exclamation text-danger" aria-hidden="true"></i></span>)}</div>
                        </>)}
                    </div>
                </>
            )))}
        </>
    );
};

export const DeleteRows = ({ cancelRemoveRowDialog, acceptRemoveRowDialog }) => {
    return (
        <div className="border-bottom pb-3">
            <Dialog
                title="Changing this row may alter configuration"
                width={"30%"}
                onClose={cancelRemoveRowDialog}
            >
                <div className="d-flex my-3 align-items-center save-content">
                    <i className="fas fa-exclamation-triangle text-warning display-7 me-3"></i>
                    <div>You are about to change data types from number to dateTime and viceversa. Changing this attribute section will remove rows that are not of the same data type. To continue click accept.</div>
                </div>
                <DialogActionsBar layout="end">
                    <button type={'button'} className="btn btn-secondary" onClick={cancelRemoveRowDialog}>
                        Cancel
                    </button>
                    <button autoFocus={true} type={'submit'} onClick={(e) => acceptRemoveRowDialog(e)} className="btn btn-primary">
                        Accept
                    </button>
                </DialogActionsBar>
            </Dialog>
        </div>
    );
}


const FormulaDialog = ({ allAttributes, entityId, attributeName, attributeType, getFormula, setFormula, numberType, formulaStatus, resetFlag, disableSwitch, parentSaveDisabled }) => {


    var formulaText = '';
    var isCirc = false;
    const defaultJson = {
        id: '', name: '', type: '', formula: '', oncreate: true, onupdate: true,
        groups: [
            {
                groupid: '',
                operatorMId: '',
                functions: [{ groupdataid: '', operatorSId: '', operatorS: '', fieldId: '', field: '' }],
                operatorM: ''
            }]
    };

    //#region State variables
    const [formula, setFormulaJson] = useState(defaultJson);
    const [jsonData, setJsonData] = useState(defaultJson);
    const [attrList, setAttrList] = useState([]);
    const [operators, setOperators] = useState({});
    const [circularReference, setCircularReference] = useState(false);
    const [formulaInvalid, setFormulaInvalid] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [buttonStatus, setButtonDisableStatus] = useState(true);
    const [toggle, setToggle] = useState(false);
    const [loading, setLoading] = useState(true);
    const [allLinkedAttributes, setLinkedAttribute] = useState([]);
    const formulaOld = setFormula.formula;

    const { t, ready: tReady } = useTranslation([
        "attribute/formula",
    ]);

    //#endregion 

    //#region Hooks
    // useEffect(() => {
    //     setLoading(parentSaveDisabled);
    // }, [parentSaveDisabled]);
    useEffect(() => {
        (async () => {
            var allLAList = await getRelatedEntityAttributes(entityId, "Number");
            allLAList.forEach((x) => {
                // Attribute types are not altered for related entity attributes
                // since they are handled in the getRelatedEntityAttributes API
                let attributeName = x.attributeName === "[SYS] ID" ? "ID" : x.attributeName;
                x.attributeName = x.entityName + '.' + (attributeName === "ID" ? "Id" : attributeName);
                x.displayName = x.entityName + '.' + attributeName;
                x.isLinkedAttr = true;
                if (attributeName === "ID") { x.isIdAttribute = true; };
            });
            setLinkedAttribute(allLAList);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            
            setLoading(true);
            await onAttributePanelChange();
        })();
    }, [entityId, attributeType, allLinkedAttributes, resetFlag]);

    useEffect(() => {
        (async () => {
            
            setLoading(true);
            await onAttributePanelChange();
        })();
    }, [attributeName]);
    //#endregion 

    const onAttributePanelChange = () => {
        (async () => {
            
            const allAttributesData = allAttributes;
            var allAttributesObj = [];

            allAttributesData.forEach((x) => {
                x.isLinkedAttr = false;
            });
            if (attributeType === "Number") {
                allAttributesObj = allAttributesData.concat(allLinkedAttributes);
            }
            else {
                allAttributesObj = allAttributesData;
            }

            allAttributesObj = allAttributesObj.map(attr => ({
                ...attr,
                attributeType: (
                    attr.attributeType === "Mirror" ?
                        attr.attribute ? attr.attribute.attributeType : attr.mirrorPropertyType
                        :
                        attr.attributeType
                )
            }))
            setLoading(false);
            let data = allAttributesObj
                .filter((x) => (x.attributeType === attributeType && x.attributeName !== attributeName) || x.isIdAttribute)
                .sort((a, b) => a.attributeName.localeCompare(b.attributeName));
            if (attributeType === "Number") {
                data = allAttributesObj
                    .filter((x) => (
                        x.group === "" && x.attributeType === attributeType ||
                        x.attributeType === "DateTime" && x.attributeName !== attributeName
                    ) ||
                        x.isIdAttribute
                    )
                    .sort((a, b) => a.attributeName.localeCompare(b.attributeName));
                data.unshift({ attributeName: "@Today", id: newGuid(), attributeType: "DateTime", dateTimeType: "date", isLinkedAttr: false, isSystemAttribute: false });
                data.unshift({ attributeName: "Fixed Number", attributeType: "Number", isLinkedAttr: false, isSystemAttribute: false });
            } else if (attributeType === "String") {
                data.unshift({ attributeName: "Comma", id: newGuid(), attributeType: "String" });
                data.unshift({ attributeName: "Space", id: newGuid(), attributeType: "String" });
            }
            const attrList = data.map(attribute => ({ ...attribute, displayName: attribute.attributeName }));
            setAttrList(attrList);

            const operators = AttributeTypes.Operations.filter(
                (x) => x.type === attributeType
            );
            setOperators(operators && operators.length > 0 ? operators[0] : []);
            let baseJson = defaultJson;
            formulaUpdateCheck(false);
            setToggle(false);
            if (setFormula && setFormula.formulaJson) {
                let groups = JSON.parse(setFormula.formulaJson);
                baseJson.groups = groups;
                baseJson.formula = setFormula.formula;
            }
            if (setFormula && setFormula.triggerSetting && setFormula.triggerSetting.length > 0) {
                //onUpdate
                let triggerSetting = JSON.parse(setFormula.triggerSetting);
                baseJson.oncreate = triggerSetting.onCreate;
                baseJson.onupdate = triggerSetting.onUpdate;
                if (triggerSetting.formulaEnabled != undefined) {
                    setToggle(triggerSetting.formulaEnabled);
                }
            }
            let obj = assignAttrIds(baseJson);
            obj.name = attributeName;
            obj.type = attributeType;
            setFormulaJson(obj);
        })();
    }


    const onAttributeRowChange = (eventInfo) => {
        let groupid = eventInfo.groupid;
        let groupdataid = eventInfo.groupdataid;
        let attribute = eventInfo.targetVal;
        let form = formula.groups.filter(e => e.groupid === groupid);
        let index = formula.groups.findIndex(e => e.groupid === groupid);
        if (form[0].functions.length > 1 && form[0].functions[0].groupdataid === groupdataid) {
            if (attribute === '' || attribute === null || (attribute != '' && form[0].functions[0].field != attribute.attributeName)) {
                let currentData = form[0].functions.filter(e => e.groupdataid !== groupdataid);// get list of functions without selected row to delete
                let attrFilterList = [];
                if (currentData.length > 0) {
                    let formulaData = form[0].functions.filter(e => e.groupdataid === groupdataid);
                    if (attribute != '' && attribute != null && attribute != undefined) {
                        let attrType = attrList.find(attr => attr.attributeName === attribute.attributeName);
                        attrFilterList = [...attrList.filter(attr => attr.attributeType === attrType.attributeType)];
                        let data = [];
                        currentData.forEach((x) => {
                            if (attrFilterList.find(attr => attr.attributeName === x.field))
                                data.push(x);
                        });
                        if (data.length > 0) {
                            formulaData = [...formulaData, ...data];
                        }
                        else {
                            formula.groups[index].functions[0].operatorM = '';
                        }
                    }
                    else {
                        formula.groups[index].functions[0].operatorM = '';
                    }
                    formula.groups[index].functions = formulaData;
                    // formula.groups[index].operatorM = '';
                    //  formula.groups[index].isWarning = false;
                    formula.formula = generateFormula();
                    setFormulaJson({ ...formula });
                    setCircularStatus();
                    formulaUpdateCheck(true);
                }
            }
        }

        isCirc = false;
        let currentData = form[0].functions.filter(e => e.groupdataid === groupdataid);
        currentData[0].field = attribute ? attribute.attributeName : "";
        currentData[0].isLinkedAttr = false;
        if (attribute && attribute.isLinkedAttr !== undefined) {
            if (attribute.isLinkedAttr) {
                currentData[0].isLinkedAttr = true;
                currentData[0].linkedEntityfield = attribute ? attribute.entitySysName : "";
                currentData[0].linkeAttributefield = attribute ? attribute.sysName : "";
            }
        }
        if (attribute && attribute.attributeName && attribute.attributeName.length > 0) {
            // When changing the attribute, checking that selected attribute has circular reference or not
            let attrObj = attrList.filter(attr => attr.attributeName === attribute.attributeName);
            if (attrObj && attrObj.length > 0) {
                let formula = attrObj[0].formula;
                if (formula && formula.length > 0) {
                    isCirc = checkCircularDepen(attribute.attributeName);
                    currentData[0].isCircular = isCirc;// isCircular will be used to indicate in each row with warning icon
                }
                else {
                    currentData[0].isCircular = false;
                    isCirc = false;
                }
            }
        }
        else {
            if (formula.type === "DateTime") {
                currentData[0].operatorS = "";
                currentData[0].value = "";
            }
            else if (formula.type === "Number") {
                currentData[0].value = "";
            }
        }

        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        setCircularStatus();
        formulaUpdateCheck(true);
    };
    //#region Events
    const onAttribute1Change = (e) => {
        
        isCirc = false;
        let groupid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupid') ? e.target.getAttribute('groupid') : e.target.props.groupid;
        let groupdataid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupdataid') ? e.target.getAttribute('groupdataid') : e.target.props.groupdataid;
        let attribute = e.target.value;
        let form = formula.groups.filter(e => e.groupid === groupid);
        let currentData = form[0].functions.filter(e => e.groupdataid === groupdataid);
        currentData[0].field = attribute ? attribute.attributeName : "";
        currentData[0].isLinkedAttr = false;
        if (attribute && attribute.isLinkedAttr !== undefined) {
            if (attribute.isLinkedAttr) {
                currentData[0].isLinkedAttr = true;
                currentData[0].linkedEntityfield = attribute ? attribute.entitySysName : "";
                currentData[0].linkeAttributefield = attribute ? attribute.sysName : "";
            }
        }
        if (attribute && attribute.attributeName && attribute.attributeName.length > 0) {
            // When changing the attribute, checking that selected attribute has circular reference or not
            let attrObj = attrList.filter(attr => attr.attributeName === attribute.attributeName);
            if (attrObj && attrObj.length > 0) {
                let formula = attrObj[0].formula;
                if (formula && formula.length > 0) {
                    isCirc = checkCircularDepen(attribute.attributeName);
                    currentData[0].isCircular = isCirc;// isCircular will be used to indicate in each row with warning icon
                }
                else {
                    currentData[0].isCircular = false;
                    isCirc = false;
                }
            }

        }
        else {
            if (formula.type === "String") {
                currentData[0].operatorS = "";
            }
            else if (formula.type === "DateTime") {
                currentData[0].operatorS = "";
                currentData[0].value = "";
            }
            else if (formula.type === "Number") {
                currentData[0].value = "";
            }
        }
        if (attribute && attribute.attributeType !== "Number") {
            currentData[0].operatorM = '';
        }
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        setCircularStatus();
        formulaUpdateCheck(true);

    };
    const onExpoChange = (e) => {
        let groupid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupid') ? e.target.getAttribute('groupid') : e.target.props.groupid;
        let groupdataid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupdataid') ? e.target.getAttribute('groupdataid') : e.target.props.groupdataid;
        let form = formula.groups.filter(e => e.groupid === groupid);
        let currentData = form[0].functions.filter(e => e.groupdataid === groupdataid);
        let attribute = e.target.value;
        currentData[0].expValue = attribute ? attribute : "";
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        formulaUpdateCheck(true);
    };
    const setAttribute2Value = (e) => {
        let groupid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupid') ? e.target.getAttribute('groupid') : e.target.props.groupid;
        let groupdataid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupdataid') ? e.target.getAttribute('groupdataid') : e.target.props.groupdataid;
        let form = formula.groups.filter(e => e.groupid === groupid);
        let currentData = form[0].functions.filter(e => e.groupdataid === groupdataid);
        currentData[0].value = e.target.value;
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        formulaUpdateCheck(true);
    }
    const onAttribute2Change = (e) => {
        let counter = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('action') ? e.target.getAttribute('action') : '';
        let groupid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupid') ? e.target.getAttribute('groupid') : e.target.props.groupid;
        let groupdataid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupdataid') ? e.target.getAttribute('groupdataid') : e.target.props.groupdataid;
        let form = formula.groups.filter(e => e.groupid === groupid);
        let currentData = form[0].functions.filter(e => e.groupdataid === groupdataid);
        if (counter && counter === "-") {
            currentData[0].value = currentData[0].value === "" || currentData[0].value <= 1 ? "1" : --currentData[0].value;
        }
        else if (counter && counter === "+") {
            currentData[0].value = currentData[0].value === "" ? "1" : ++currentData[0].value;
        }
        else {
            let attribute = e.target.value;
            currentData[0].value = attribute ? attribute : "";
        }
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        formulaUpdateCheck(true);
    };
    const onConnectorChange = (e) => {
        let groupid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupid') ? e.target.getAttribute('groupid') : e.target.props.groupid;
        let connector = e.target.value;
        let form = formula.groups.filter(e => e.groupid === groupid);
        form[0].operatorM = connector ? connector : "";
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        formulaUpdateCheck(true);
    };
    const onRemoveRow = (e) => {

        let groupid = '';
        let groupdataid = '';
        if (e.target.parentElement && e.target.parentElement.getAttribute('groupid')) {
            groupid = e.target.parentElement.getAttribute('groupid');
        }
        if (e.target.parentElement && e.target.parentElement.getAttribute('groupdataid')) {
            groupdataid = e.target.parentElement.getAttribute('groupdataid');
        }
        let form = formula.groups.filter(e => e.groupid === groupid);
        if (form.length > 0) {
            let currentData = form[0].functions.filter(e => e.groupdataid !== groupdataid);// get list of functions without selected row to delete
            if (currentData.length <= 0) {// if the function is having only one row; removing the group itself
                let formulaData = formula.groups.filter(e => e.groupid !== groupid);
                formula.groups = formulaData;
            }
            else {
                if (formula.groups.findIndex(e => e.groupid === groupid) > 0
                    && (formula.groups[formula.groups.findIndex(e => e.groupid === groupid)].functions[0].operatorM ===
                        formula.groups[0].functions[0].operatorM)) {
                    currentData[currentData.length - 1].field = '';
                }
                // when we are removing a row OpertorM also should be blank
                if (formula.type === "String") {
                    currentData[currentData.length - 1].operatorS = '';
                }
                else if (formula.type === "Number") {
                    currentData[currentData.length - 1].operatorM = '';
                }
            }
            form[0].functions = currentData;// update the function without selected row to delete
        }
        formula.groups[formula.groups.length - 1].operatorM = '';
        formula.groups[formula.groups.length - 1].isWarning = false;
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        setCircularStatus();
        formulaUpdateCheck(true);
    };
    const onMultiOperatorChange = (e) => {
        let groupid = e.target && typeof e.target.getAttribute === 'function' && e.target.getAttribute('groupid')
            ? e.target.getAttribute('groupid')
            : e.target.props.groupid;
        let groupdataid = e.target && typeof e.target.getAttribute === 'function' && e.target.getAttribute('groupdataid')
            ? e.target.getAttribute('groupdataid')
            : e.target.props.groupdataid;
        let multiOperator = e.target.value;
        let form = formula.groups.filter(e => e.groupid === groupid);
        let currentData = form[0].functions.filter(e => e.groupdataid === groupdataid);
        currentData[0].operatorM = multiOperator ? multiOperator : '';

        if (multiOperator && multiOperator.length > 0) {
            if (
                form &&
                form[0] &&
                form[0].functions &&
                form[0].functions[form[0].functions.length - 1] &&
                form[0].functions[form[0].functions.length - 1].field &&
                form[0].functions[form[0].functions.length - 1].field !== '' &&
                form[0].functions[form[0].functions.length - 1].operatorM &&
                form[0].functions[form[0].functions.length - 1].operatorM !== ''
            ) {
                const newRow =
                    attributeType !== 'Number'
                        ? {
                            groupdataid: newGuid(),
                            operatorSId: newGuid(),
                            operatorS: '',
                            fieldId: newGuid(),
                            field: '',
                        }
                        : {
                            groupdataid: newGuid(),
                            operatorSId: newGuid(),
                            operatorS: '',
                            fieldId: newGuid(),
                            field: '',
                            valueId: newGuid(),
                            value: '',
                            operatorMId: newGuid(),
                            operatorM: '',
                        };
                form[0].functions.push(newRow);
            } else if (
                form &&
                form[0] &&
                form[0].functions &&
                form[0].functions.length > 1 &&
                form[0].functions[form[0].functions.length - 1].field !== '' &&
                form[0].functions[0].operatorM !== '' &&
                attrList.find((x) => x.attributeName === form[0].functions[form[0].functions.length - 1].field).attributeType === 'DateTime'
            ) {
                if (form[0].functions[form[0].functions.length - 1].field) {
                    form[0].functions[form[0].functions.length - 1].field = '';
                    form[0].functions[form[0].functions.length - 1].operatorM = '';
                    form[0].functions[form[0].functions.length - 1].operatorS = '';
                } else {
                    form[0].functions.pop(form[0].functions[form[0].functions.length - 1]);
                    const newRow = attributeType !== 'Number'
                        ? {
                            groupdataid: newGuid(),
                            operatorSId: newGuid(),
                            operatorS: '',
                            fieldId: newGuid(),
                            field: '',
                        }
                        : {
                            groupdataid: newGuid(),
                            operatorSId: newGuid(),
                            operatorS: '',
                            fieldId: newGuid(),
                            field: '',
                            valueId: newGuid(),
                            value: '',
                            operatorMId: newGuid(),
                            operatorM: '',
                        };
                    form[0].functions.push(newRow);
                }
                formula.formula = generateFormula();
                setFormulaJson({ ...formula });
                formulaUpdateCheck(true);
            }
        }
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        formulaUpdateCheck(true);
    };



    const onOperatorChange = (e) => {
        let groupid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupid') ? e.target.getAttribute('groupid') : e.target.props.groupid;
        let groupdataid = e.target && typeof e.target.getAttribute == 'function' && e.target.getAttribute('groupdataid') ? e.target.getAttribute('groupdataid') : e.target.props.groupdataid;
        let operator = e.target.value;
        let excludeValues = ["capitalize", "lower case", "first letter"];
        let form = formula.groups.filter(e => e.groupid === groupid);
        let currentData = form[0].functions.filter(e => e.groupdataid === groupdataid);
        currentData[0].operatorS = operator ? operator : "";
        if (formula.type === "String") {
            if (operator && operator.length > 0) {
                if (!excludeValues.includes(operator)) {
                    if (form && form[0] && form[0].group && form[0].group[form[0].functions.length - 1].field !== '' && form[0].group[form[0].functions.length - 1].operatorS !== '') {
                        const newRow = attributeType !== "Number" ? { groupdataid: newGuid(), operatorSId: newGuid(), operatorS: '', fieldId: newGuid(), field: '' } : { groupdataid: newGuid(), operatorSId: newGuid(), operatorS: '', fieldId: newGuid(), field: '', valueId: newGuid(), value: '', operatorMId: newGuid(), operatorM: '' }
                        form[0].functions.push(newRow);
                    }
                }
                else {
                    //remove if row exist
                    removeLastRow(groupid, groupdataid);
                }
            }
            else {
                currentData[0].value = "";
            }
        }
        else if (formula.type === "DateTime" && operator !== "Between") {
            if (operator && operator.length > 0) {
                currentData[0].value = "1";
            }
            else {
                currentData[0].value = "";
            }
        }
        else {
            if (currentData[0].field !== 'Fixed Number') {
                currentData[0].value = "";
            }
            currentData[0].expValue = "";
        }
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
        formulaUpdateCheck(true);
    };
    const addGroup = (e) => {
        const newRow = attributeType !== "Number" ? { groupdataid: newGuid(), operatorSId: newGuid(), operatorS: '', fieldId: newGuid(), field: '' } : { groupdataid: newGuid(), operatorSId: newGuid(), operatorS: '', fieldId: newGuid(), field: '', valueId: newGuid(), value: '', operatorMId: newGuid(), operatorM: '' }
        let newGroup = {
            groupid: newGuid(),
            functions: [newRow],
            operatorMId: newGuid(),
            operatorM: ''
        };
        formula.groups.push(newGroup);
        setFormulaJson({ ...formula });
        formulaUpdateCheck(true);
    };
    const onTriggerCreate = (event) => {
        if (event.value) {
            formula.oncreate = event.value;
            setFormulaJson({ ...formula });
        }
        else {
            formula.oncreate = event.value;
            formula.onupdate = event.value;
            setFormulaJson({ ...formula });
        }
        if (formula.formula === setFormula.formula) {
            formulaUpdated(false);
        }
        let triggerSettingObject = JSON.parse(setFormula.triggerSetting);
        if (triggerSettingObject.onCreate) {
            if (triggerSettingObject.onCreate !== event.value || triggerSettingObject.onUpdate === true) {
                formulaUpdated(true);
            } else {
                formulaUpdated(false);
            }

        } else if (event.value === true) {
            formulaUpdated(true);
        } else {
            formulaUpdated(false);
        }

    }
    const onTriggerUpdate = (event) => {
        if (event.value) {
            formula.oncreate = event.value;
            formula.onupdate = event.value;
            setFormulaJson({ ...formula });
        }
        else {
            formula.onupdate = event.value;
            setFormulaJson({ ...formula });
        }

        let triggerSettingObject = JSON.parse(setFormula.triggerSetting);
        if (triggerSettingObject.onUpdate) {
            if (triggerSettingObject.onUpdate !== event.value || (triggerSettingObject.onCreate !== formula.oncreate)) {
                formulaUpdated(true);
            } else {
                if (formula.formula === setFormula.formula)
                    formulaUpdated(false);
            }

        } else if (event.value === true || triggerSettingObject.onCreate !== formula.oncreate) {
            formulaUpdated(true);
        } else {
            formulaUpdated(false);
        }
    }
    const closeFormulaDialog = () => {
        if (setFormula && setFormula.formula) {
            formula.formula = setFormula.formula;
            formula.groups = JSON.parse(setFormula.formulaJson);
            if (setFormula && setFormula.triggerSetting && setFormula.triggerSetting.length > 0) {
                let triggerSetting = JSON.parse(setFormula.triggerSetting);
                formula.oncreate = triggerSetting.onCreate;
                formula.onupdate = triggerSetting.onUpdate;
                formula.formulaEnabled = triggerSetting.formulaEnabled;
            }
            let obj = assignAttrIds(formula);
            setFormulaJson(obj);
        }
        else {
            let baseJson = defaultJson;
            if (setFormula && setFormula.formulaJson) {
                let groups = JSON.parse(setFormula.formulaJson);
                baseJson.groups = groups;
                baseJson.formula = setFormula.formula;
            }
            if (setFormula && setFormula.triggerSetting && setFormula.triggerSetting.length > 0) {
                let triggerSetting = JSON.parse(setFormula.triggerSetting);
                if (triggerSetting.onCreate !== undefined) {
                    baseJson.oncreate = triggerSetting.onCreate;
                }

                if (triggerSetting.onUpdate !== undefined) {
                    baseJson.onupdate = triggerSetting.onUpdate;
                }

            }
            let obj = assignAttrIds(baseJson);
            obj.name = attributeName;
            obj.type = attributeType;
            setFormulaJson(obj);
        }
        setFormulaInvalid(false);
        setCircularReference(false);
        setButtonDisableStatus(true);
        setShowDialog(false);
    }
    const onSaveFormulaBuilder = () => {
        checkWarning();
    }
    const showFormula = (e) => {
        setToggle(e.target.value);
        formulaStatus(e.target.value);
        // if (formula.formula != undefined && formula.formula.length > 0) {
        //     formulaStatus(e.target.value);
        // }
    }
    //#endregion

    //#region Methods
    const setCircularStatus = () => {
        let isCircular = false;
        formula.groups.forEach(group => {
            group.functions.forEach(fnc => {
                if (fnc.field !== undefined && fnc.field.length > 0) {
                    if (fnc.isCircular === true) {
                        isCircular = true;
                    }
                }
            });
        });
        setCircularReference(isCircular);
    }
    const formulaUpdateCheck = (val) => {
        if (isCirc) {
            formulaUpdated(false);
        }
        else {
            formulaUpdated(formulaOld && formulaOld === formula.formula ? false : val);
        }
    }
    const checkWarning = () => {
        if (formula && formula.groups && formula.groups.length > 0) {
            switch (formula.type) {
                case "String":
                    return checkStringWarning();
                case "Number":
                    return checkNumberWarning();
                case "DateTime":
                    return checkDateTimeWarning();

                default:
                    return "";
            }
        }
    }
    const checkNumberWarning = () => {
        let isInvalid = false;
        let groupIndex = 0;

        formula.groups.forEach(group => {
            groupIndex++;
            let funcIndex = 0;
            group.isWarning = false;
            group.isOperatorMInvalid = false;
            group.functions.forEach(fnc => {
                funcIndex++;
                fnc.isWarning = false;
                fnc.isOperatorSInvalid = false;
                fnc.isFieldInvalid = false;
                fnc.isExponentInvalid = false;
                fnc.isValueInvalid = false;
                fnc.isOperatorMInvalid = false;
                //#region OperatorS 

                //If Operator is there
                if (fnc.operatorS !== undefined && fnc.operatorS.length > 0) {
                    if (fnc.operatorS === 'exponent') {
                        if (!fnc.expValue || (fnc.expValue !== undefined && fnc.expValue.length <= 0)) {
                            fnc.isWarning = true;
                            fnc.isExponentInvalid = true;
                        }
                        if (fnc.field !== undefined && fnc.field.length > 0) {
                            if (fnc.field === 'Fixed Number') {
                                if (!fnc.value || (fnc.value !== undefined && fnc.value.length <= 0)) {
                                    fnc.isValueInvalid = true;
                                    fnc.isWarning = true;
                                }
                            }
                        }
                        else {
                            fnc.isWarning = true;
                            fnc.isFieldInvalid = true;
                        }
                    }
                    else if (fnc.field !== undefined && fnc.field.length > 0) {
                        if (fnc.field === 'Fixed Number') {
                            if (!fnc.value || (fnc.value !== undefined && fnc.value.length <= 0)) {
                                fnc.isValueInvalid = true;
                                fnc.isWarning = true;
                            }
                        }
                    }
                    else {
                        fnc.isFieldInvalid = true;
                        fnc.isWarning = true;
                    }
                }
                //Operator Not selected
                else if (fnc.field !== undefined && fnc.field.length > 0) {
                    if (fnc.field === 'Fixed Number') {
                        if (!fnc.value || (fnc.value !== undefined && fnc.value.length <= 0)) {
                            fnc.isValueInvalid = true;
                            fnc.isWarning = true;
                        }
                    }
                    else if (fnc.isLinkedAttr !== undefined && fnc.isLinkedAttr) {
                        fnc.isOperatorSInvalid = true;
                        fnc.isWarning = true;
                    }
                }
                //both OperatorS and field are empty
                else if (!fnc.operatorS || (fnc.operatorS !== undefined && fnc.operatorS.length <= 0) && !fnc.field && (fnc.field != undefined && fnc.field.length <= 0)) {
                    fnc.isFieldInvalid = true;
                    fnc.isWarning = true;
                }
                else {
                    fnc.isFieldInvalid = true;
                    fnc.isWarning = true;
                }
                if (funcIndex < group.functions.length) {
                    if (!fnc.operatorM || (fnc.operatorM !== undefined && fnc.operatorM.length <= 0)) {
                        //warning
                        fnc.isOperatorMInvalid = true;
                        fnc.isWarning = true;
                    }
                }
                if (fnc.isWarning === true) {
                    isInvalid = true;
                }
                //#endregion 
            });

            if (formula.groups[groupIndex] !== undefined) {
                if (!group.operatorM || (group.operatorM !== undefined && group.operatorM.length <= 0)) {
                    isInvalid = true;
                    group.isWarning = true;
                    group.isOperatorMInvalid = true;
                }
            }
        });
        setFormulaJson({ ...formula });
        setFormulaInvalid(isInvalid);
        if (!isInvalid) {
            getFormula({ 'formula': generateFormula(), 'formulaJson': exportJson().groups, 'circularReference': circularReference, 'validFormula': isInvalid === false ? true : false, 'triggerSetting': { 'onCreate': formula.oncreate, 'onUpdate': formula.onupdate, 'formulaEnabled': toggle } });
        }
        saveStatus(!isInvalid);
    }
    const checkStringWarning = () => {
        let isInvalid = false;
        let groupIndex = 0;
        formula.groups.forEach(group => {
            groupIndex++;
            let funcIndex = 0;
            group.isWarning = false;
            group.isOperatorMInvalid = false;
            group.functions.forEach(fnc => {
                funcIndex++;
                fnc.isWarning = false;
                fnc.isOperatorSInvalid = false;
                fnc.isFieldInvalid = false;
                //#region OperatorS 

                //If Operator is there
                if (fnc.operatorS !== undefined && fnc.operatorS.length > 0) {
                    if (!fnc.field || (fnc.field !== undefined && fnc.field.length <= 0)) {
                        fnc.isWarning = true;
                        fnc.isFieldInvalid = true;
                    }
                }
                else if (!fnc.field || (fnc.field !== undefined && fnc.field.length <= 0)) {
                    fnc.isWarning = true;
                    fnc.isFieldInvalid = true;
                }
                if (funcIndex < group.functions.length) {
                    if (!fnc.operatorM || (fnc.operatorM !== undefined && fnc.operatorM.length <= 0)) {
                        fnc.isOperatorMInvalid = true;
                        fnc.isWarning = true;
                    }
                }
                if (fnc.isWarning === true) {
                    isInvalid = true;
                }
                //#endregion  
            });
            if (formula.groups[groupIndex] !== undefined) {
                if (!group.operatorM && (group.operatorM !== undefined && group.operatorM.length <= 0)) {
                    isInvalid = true;
                    group.isWarning = true;
                    group.isOperatorMInvalid = true;
                }
            }
        });
        setFormulaJson({ ...formula });
        setFormulaInvalid(isInvalid);
        if (!isInvalid) {
            getFormula({ 'formula': generateFormula(), 'formulaJson': exportJson().groups, 'circularReference': circularReference, 'validFormula': isInvalid === false ? true : false, 'triggerSetting': { 'onCreate': formula.oncreate, 'onUpdate': formula.onupdate, 'formulaEnabled': toggle } });
        }
        saveStatus(!isInvalid);
    }
    const checkDateTimeWarning = () => {
        let isInvalid = false;
        let groupIndex = 0;
        formula.groups.forEach(group => {
            groupIndex++;
            let funcIndex = 0;
            group.isWarning = false;
            group.isOperatorMInvalid = false;
            group.functions.forEach(fnc => {
                funcIndex++;
                fnc.isWarning = false;
                fnc.isOperatorSInvalid = false;
                fnc.isFieldInvalid = false;
                //#region OperatorS 

                //If Operator is there
                if (fnc.operatorS !== undefined && fnc.operatorS.length > 0) {
                    if (!fnc.field || (fnc.field !== undefined && fnc.field.length <= 0)) {
                        fnc.isWarning = true;
                        fnc.isFieldInvalid = true;
                        fnc.isOperatorSInvalid = false;
                    }
                }
                else if (fnc.field !== undefined && fnc.field.length > 0) {
                    if (!fnc.operatorS || (fnc.operatorS !== undefined && fnc.operatorS.length <= 0)) {
                        fnc.isWarning = true;
                        fnc.isFieldInvalid = false;
                        fnc.isOperatorSInvalid = true;
                    }
                }
                else {
                    fnc.isWarning = true;
                    fnc.isFieldInvalid = true;
                    fnc.isOperatorSInvalid = true;
                }

                if (fnc.isWarning === true) {
                    isInvalid = true;
                }
                //#endregion  
            });

        });
        setFormulaJson({ ...formula });
        setFormulaInvalid(isInvalid);
        if (!isInvalid) {
            getFormula({ 'formula': generateFormula(), 'formulaJson': exportJson().groups, 'circularReference': circularReference, 'validFormula': isInvalid === false ? true : false, 'triggerSetting': { 'onCreate': formula.oncreate, 'onUpdate': formula.onupdate, 'formulaEnabled': toggle } });
        }
        saveStatus(!isInvalid);
    }
    const newGuid = () => {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }
    // checkin circular reference for passing attribute
    const checkCircularDepen = (selectedAttr) => {
        let isCircular = false;
        let attrObj = attrList.filter(attr => attr.attributeName === selectedAttr);
        if (attrObj && attrObj.length > 0) {
            let formula = attrObj[0].formula;
            const formulaJson = attrObj[0].formulaJson;
            const json = formulaJson ? JSON.parse(formulaJson) : [];

            if (formula && formula.length > 0 && json && json.length > 0) {
                for (const func of json) {
                    if (func && func.functions) {
                        for (const functionObj of func.functions) {
                            // here do not compare lower case or upper case of attribute name
                            // because different attributes like Attr1, attr1, aTTr1, etc. would be considered as different attributes
                            // as we do not store id of attribute for some reason
                            if (functionObj && functionObj.field && functionObj.field === attributeName) {
                                isCircular = true;
                                return true;
                            } else if (functionObj && functionObj.field) {
                                let res = checkCircularDepen(functionObj.field);
                                if (res) {
                                    isCircular = true;
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
        }
        return isCircular;
    }
    const removeLastRow = (groupid, groupdataid) => {
        let form = formula.groups.filter(e => e.groupid === groupid);
        if (form.length > 0 && form[0].group && form[0].functions.length > 1) {
            if (form[0].group[form[0].functions.length - 1].operatorS === "") {
                form[0].functions.pop();
            }
        }
        formula.formula = generateFormula();
        setFormulaJson({ ...formula });
    }
    const assignAttrIds = (json) => {
        json.id = newGuid();
        if (json.groups && json.groups.length > 0) {
            json.groups.forEach(group => {
                group.groupid = newGuid();
                group.operatorMId = newGuid();
                if (group && group.functions && group.functions.length > 0) {
                    group.functions.forEach(row => {
                        row.groupdataid = newGuid();
                        row.fieldId = newGuid();
                        row.operatorSId = newGuid();
                    });
                }
            });
        }
        return json;
    }
    // removing all DOM Id reference before saving to DB
    const exportJson = () => {
        if (formula && formula.groups && formula.groups.length > 0) {
            let json = structuredClone(formula);
            json.groups.forEach(group => {
                delete group.groupid;
                delete group.operatorMId;
                delete group.isOperatorMInvalid;
                delete group.isWarning;
                if (!group.operatorM || group.operatorM !== undefined && group.operatorM.length <= 0) {
                    delete group.operatorM;
                }
                group.functions.forEach(fnc => {
                    delete fnc.fieldId;
                    delete fnc.isWarning;
                    delete fnc.isOperatorSInvalid;
                    delete fnc.isExponentInvalid;
                    delete fnc.isFieldInvalid;
                    delete fnc.isValueInvalid;
                    delete fnc.isOperatorMInvalid;

                    if (!fnc.field || fnc.field !== undefined && fnc.field.length <= 0) {
                        delete fnc.field;
                    }
                    delete fnc.groupdataid;
                    delete fnc.operatorSId;
                    if (!fnc.operatorS || fnc.operatorS !== undefined && fnc.operatorS.length <= 0) {
                        delete fnc.operatorS;
                    }
                    delete fnc.operatorMId;
                    if (!fnc.operatorM || fnc.operatorM !== undefined && fnc.operatorM.length <= 0) {
                        delete fnc.operatorM;
                    }
                    delete fnc.valueId;
                    if (!fnc.value || fnc.value !== undefined && fnc.value.length <= 0) {
                        delete fnc.value;
                    }
                    //expValue
                    if (!fnc.expValue || fnc.expValue !== undefined && fnc.expValue.length <= 0) {
                        delete fnc.expValue;
                    }
                    if (formula.type === "Number") {
                        reOrderNumProperty(fnc);
                    }
                });
            });
            setJsonData(json);
            return json;
        }

    }
    const generateNumberFormula = () => {

        formulaText = '';
        if (formula && formula.groups && formula.groups.length > 0) {
            formula.groups.forEach(group => {
                if (group && group.functions && group.functions.length > 1)
                    formulaText += '(';
                if (group && group.functions && group.functions.length > 0) {
                    group.functions.forEach(row => {

                        if (row.operatorS && row.operatorS.length > 0) {

                            if (row.operatorS === 'exponent') {
                                let fieldValue = row.field === 'Fixed Number' ? row.value < 0 ? '(' + row.value + ')' : row.value : row.field ? row.field : "";
                                let expo = row.expValue ? row.expValue < 0 ? '(' + row.expValue + ')' : row.expValue.toString() : '';
                                formulaText += '(' + (fieldValue + "^" + expo + ')');
                            }
                            else if (row.operatorS === 'absolute') {
                                formulaText += 'abs (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === 'count') {
                                formulaText += 'count (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === 'min') {
                                formulaText += 'min (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === 'max') {
                                formulaText += 'max (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === 'avg') {
                                formulaText += 'avg (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === 'sum') {
                                formulaText += 'sum (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === "round") {
                                formulaText += 'round (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === "floor") {
                                formulaText += 'floor (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === "ceil") {
                                formulaText += 'ceil (' + (row.field === 'Fixed Number' ? row.value : row.field ? row.field : "") + ')';
                            }
                            else if (row.operatorS === '') {
                                formulaText += (row.field === 'Fixed Number' ? "" : row.field ? row.field : "");
                            }
                        }
                        else {
                            formulaText += (row.field === 'Fixed Number' ? row.value ? row.value < 0 ? '(' + row.value + ')' : row.value : "" : row.field ? row.field : "");
                        }
                        if (row.operatorM && row.operatorM.length > 0) {
                            if (row.operatorM === 'divide') {
                                formulaText += ' / ';
                            }
                            else if (row.operatorM === 'multiply') {
                                formulaText += ' x ';
                            }
                            else if (row.operatorM === 'subtract' || row.operatorM === 'minutes between' || row.operatorM === 'hours between' || row.operatorM === 'days between' || row.operatorM === 'weeks between' || row.operatorM === 'months between' || row.operatorM === 'years between') {
                                formulaText += ' - ';
                            }
                            else if (row.operatorM === 'add') {
                                formulaText += ' + ';
                            }
                            else if (row.operatorM === 'modular') {
                                formulaText = formulaText + (row.field === 'Fixed Number' || row.operatorM.length > 0 ? "" : row.field ? row.field : "") + ' % ';
                            }

                        }
                    });
                }
                if (group && group.functions && group.functions.length > 1)
                    formulaText += ')';
                if (group.operatorM === 'add') {
                    formulaText += ' + ';
                }
                if (group.operatorM === 'subtract') {
                    formulaText += ' - ';
                }
                if (group.operatorM === 'divide') {
                    formulaText += ' / ';
                }
                if (group.operatorM === 'multiply') {
                    formulaText += ' x ';
                }
            });
        }
        formulaText = formulaText === '()' ? '' : formulaText;

        return formulaText;
    }
    const generateDateTimeFormula = () => {
        formulaText = '';
        if (formula.groups && formula.groups.length > 0) {
            formula.groups.forEach(group => {
                if (group && group.functions && group.functions.length > 0) {
                    group.functions.forEach(row => {
                        if (row.field && row.field && row.field.length > 0) {
                            if (row.operatorS && row.operatorS === 'plus') {
                                formulaText += row.field + ' + ' + row.value + ' day(s)';
                            }
                            else if (row.operatorS && row.operatorS === 'minus') {
                                formulaText += row.field + ' - ' + row.value + ' day(s)';
                            }
                            else {
                                formulaText += row.field;

                            }
                        }
                    });
                }
            });
        }
        formulaText = formulaText === '()' ? '' : formulaText;
        return formulaText;
    }
    const generateStringFormula = () => {
        formulaText = '';
        if (formula.groups && formula.groups.length > 0) {
            formula.groups.forEach(group => {
                if (group && group.functions && group.functions.length > 1)
                    formulaText += '(';
                if (group && group.functions && group.functions.length > 0) {
                    group.functions.forEach(row => {
                        if (row.operatorS === 'concatenate') {
                            formulaText += (row.field ? row.field : '') + ' + ';
                        }
                        else {
                            formulaText += (row.operatorS ? row.operatorS : '') + ' (' + row.field + ')';
                        }
                    });
                }
                if (group && group.functions && group.functions.length > 1)
                    formulaText += ')';
                if (group.operatorM === 'concatenate') {
                    formulaText += ' + ';
                }
            });
        }
        formulaText = formulaText.trim() === '()' ? '' : formulaText;
        return formulaText;
    }
    const generateFormula = () => {
        if (formula && formula.groups) {
            switch (formula.type) {
                case "String":
                    return generateStringFormula();
                case "Number":
                    return generateNumberFormula();
                case "DateTime":
                    return generateDateTimeFormula();

                default:
                    return "";
            }
        }
    }
    const reOrderNumProperty = (funcObj) => {
        let objFunc = Object.assign({}, funcObj);
        delete funcObj['operatorS'];
        delete funcObj['operatorM'];
        delete funcObj['field'];
        delete funcObj['expValue'];
        delete funcObj['value'];
        if (objFunc.operatorS && objFunc.operatorS !== undefined && objFunc.operatorS.length > 0) {
            funcObj['operatorS'] = objFunc['operatorS'];
        }
        if (objFunc.field && objFunc.field !== undefined && objFunc.field.length > 0) {
            funcObj['field'] = objFunc['field'];
        }
        if (objFunc.value && objFunc.value !== undefined && objFunc.value.length > 0) {
            funcObj['value'] = objFunc['value'];
        }
        if (objFunc.expValue && objFunc.expValue !== undefined && objFunc.expValue.length > 0) {
            funcObj['expValue'] = objFunc['expValue'];
        }
        if (objFunc.operatorM && objFunc.operatorM !== undefined && objFunc.operatorM.length > 0) {
            funcObj['operatorM'] = objFunc['operatorM'];
        }
    }
    const saveStatus = (val) => {
        setButtonDisableStatus(val);
        setShowDialog(!val);
    }
    const CustomTitleBar = () => {
        return (
            <>
                <div className="custom-title">
                    {t("configure_formula_for")}
                    &nbsp;
                    <span className='t-primary'>{attributeName}&nbsp;</span >
                    ({attributeType})
                </div>
            </>
        );
    };
    const formulaUpdated = (val) => {
        let triggerSettingObject = setFormula && setFormula.triggerSetting ? JSON.parse(setFormula.triggerSetting) : {};
        let oldAttr = setFormula.formula;
        let newAttr = formula.formula;
        const oldJson = setFormula && setFormula.formulaJson ? JSON.parse(setFormula.formulaJson) : [];
        let isChanged = oldJson.length !== formula.groups.length;
        if (!isChanged) {
            let { groups } = formula;
            for (let i = 0; i < oldJson.length; i++) {
                const oldGroup = oldJson[i];
                let newGroup = groups[i];
                for (let functionIndex = 0; functionIndex < oldGroup.functions.length; functionIndex++) {
                    const oldFunction = oldGroup.functions[functionIndex];
                    const newFunction = newGroup.functions[functionIndex];
                    const oldOperatorS = oldFunction.operatorS ? oldFunction.operatorS : '';
                    const oldOperatorM = oldFunction.operatorM ? oldFunction.operatorM : '';
                    if (
                        oldFunction.field !== newFunction.field ||
                        oldOperatorS !== newFunction.operatorS ||
                        oldOperatorM !== newFunction.operatorM
                    ) {
                        isChanged = true;
                        break;
                    }
                }
            }
        }
        const disableButton = !isChanged;
        newAttr = formula.type === "DateTime" ? newAttr.replace(' day(s)', '') : newAttr;
        if (formula.formula.length <= 0) {
            setButtonDisableStatus(true);
        }
        else if (newAttr === oldAttr) {
            if (triggerSettingObject && (triggerSettingObject.onCreate == undefined && formula.oncreate == true && formula.onupdate == true)) {
                setButtonDisableStatus(true);
            }
            else if (triggerSettingObject && (triggerSettingObject.onCreate === formula.oncreate && triggerSettingObject.onUpdate === formula.onupdate)) {
                setButtonDisableStatus(disableButton);
            }
            else {
                setButtonDisableStatus(disableButton);
            }
        }
        else {
            setButtonDisableStatus(disableButton);
        }
    }
    //#endregion

    return (
        <div className='mt-0'>
            <div className="form-label pt-2">
                {t("calculate_formula")}
            </div>

            {loading &&
                <FormulaLoader />
            }

            <Switch
                key={attributeName}
                name="Calculate Formula"
                defaultChecked={false}
                onChange={showFormula}
                checked={toggle}
                value={toggle}
                disabled={disableSwitch}
            />
            {toggle && (<div>
                <div className="form-label d-inline-block">
                    {t("formula")}
                </div>
                <input className="calculated-result w-100 mb-2 bold" name="Formula" readOnly={true} value={formula.formula && formula.formula.length > 0 && !showDialog ? formula.type === "DateTime" && !formula.formula.endsWith('day(s)') ? formula.formula + ' day(s)' : formula.formula : ''} />
                <span className='float-right t-primary fw-bold cursor-pointer' onClick={() => { setShowDialog(true) }}>
                    <i className="fa-solid fa-pen-to-square mx-1"></i>
                    {t("configure_formula")}
                </span>
            </div>)}

            {showDialog && (<div>
                <Dialog title={<CustomTitleBar />} onClose={closeFormulaDialog} >
                    <fieldset className="h-100">
                        <form className="d-flex flex-column h-100" >
                            <div className="form-label">
                                {t("trigger_setting")} : &nbsp;
                                <Checkbox
                                    className="sys-attr-checkbox me-2"
                                    label={t("on_create")}
                                    value={formula.oncreate}
                                    disabled={formula.formula && formula.formula.length > 0 ? false : true}
                                    onChange={onTriggerCreate} />
                                <Checkbox
                                    className="sys-attr-checkbox"
                                    label={t("on_update")}
                                    value={formula.onupdate}
                                    disabled={formula.formula && formula.formula.length > 0 ? false : true}
                                    onChange={onTriggerUpdate} />
                            </div>
                            <input className="calculated-result w-100 mb-2 bold" readOnly={true} value={generateFormula()} />
                            <div className="d-flex justify-content-between mb-2 clearBtn">
                                <div className=" border overflow-form h-300">
                                    <div className="form-label ms-4">
                                        {t("formula_builder")}
                                    </div>

                                    {formula && formula.groups && formula.groups.map((groupf, i) => (
                                        <>
                                            <div className="border-dashed m-4 mt-0">
                                                <Dropdowns
                                                    attrList={attrList}
                                                    formula={formula}
                                                    operators={operators}
                                                    groupData={groupf.functions}
                                                    groupid={groupf.groupid}
                                                    groupIndex={i}
                                                    key={i}
                                                    attributeType={attributeType}
                                                    setAttribute2Value={setAttribute2Value}
                                                    onRemoveRow={onRemoveRow}
                                                    onExpoChange={onExpoChange}
                                                    numberType={numberType}
                                                    onAttributeRowChange={onAttributeRowChange}
                                                    onAttribute1Change={onAttribute1Change}
                                                    onAttribute2Change={onAttribute2Change}
                                                    onOperatorChange={onOperatorChange}
                                                    onMultiOperatorChange={onMultiOperatorChange}

                                                />
                                            </div>

                                            {formula.type !== "DateTime" && (i < formula.groups.length - 1) && (
                                                <>
                                                    <div className="row mt-2 mb-4 position-relative ">
                                                        <div className="col-4"></div>
                                                        <div className="connector-bottom"></div>
                                                        <div className="col-4">
                                                            <ComboBox
                                                                data={operators.connectors}
                                                                name={groupf.operatorMId}
                                                                value={groupf.operatorM}
                                                                placeholder={t("operator_placeholder")}
                                                                filterable={true}
                                                                allowCustom={false}
                                                                groupid={groupf.groupid}
                                                                className={groupf.isOperatorMInvalid ? "form-control-custom invalid-formula-field" : "form-control-custom"}
                                                                onChange={onConnectorChange}
                                                            />
                                                        </div>
                                                        <div className="connector-top"></div>
                                                        <div className="col-4">{groupf.isWarning && (<span className="formula-row-close"><i class="fa-solid fa-triangle-exclamation text-danger" aria-hidden="true"></i></span>)}</div>
                                                    </div>
                                                </>
                                            )}

                                        </>
                                    ))}
                                    {operators.type !== "DateTime" && (
                                        <div className="mb-0 ">
                                            <div className="mt-12">
                                                <span
                                                    className="t-primary fw-bold cursor-pointer me-3 float-right"
                                                    onClick={addGroup}
                                                >
                                                    <i className="mx-1 fa-solid fa-plus"></i>
                                                    {t("add_group")}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {circularReference && (
                                <div>
                                    <span>
                                        <i class="fa-solid fa-triangle-exclamation text-danger" aria-hidden="true"></i>
                                        {t("errors.circular_reference_present")}
                                    </span>
                                </div>
                            )
                            }
                            {formulaInvalid && (
                                <div>
                                    <span>
                                        <i class="fa-solid fa-triangle-exclamation text-danger" aria-hidden="true"></i>
                                        {t("errors.fields_mandatory")}
                                    </span>
                                </div>
                            )
                            }
                            <DialogActionsBar layout="end">
                                <button className="btn btn-secondary" onClick={closeFormulaDialog} type="button">
                                    {t("buttons.cancel")}
                                </button>
                                <button name="CreateNew" className="btn btn-primary" disabled={circularReference === true ? true : buttonStatus} type="button" onClick={onSaveFormulaBuilder} >
                                    {t("buttons.save")}
                                </button>
                            </DialogActionsBar>
                        </form>
                    </fieldset >
                </Dialog></div>)}
        </div>
    )
}

export default FormulaDialog

